export default {
  REDDIT_URL: "https://www.reddit.com/r/dankmemes/.json?&show=all&limit=1",
};
